import StationInfo from './StationInfo/StationInfo'

import style from './StationDetails.module.css'

const StationDetails = () => {
  return (
    <div className={style.root}>
      <div className={style.tableWrapper}>
        <StationInfo />
      </div>
    </div>
  )
}

export default StationDetails
